import { Outlet } from "react-router-dom";

const MainRentalManpower = () => {
  return (
    <div className=" w-full h-full">
      <Outlet />
    </div>
  );
};

export default MainRentalManpower;
